import { render, staticRenderFns } from "./EditReturnExpand.vue?vue&type=template&id=84245dd8&"
import script from "./EditReturnExpand.vue?vue&type=script&lang=js&"
export * from "./EditReturnExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports